import React, { useState } from "react";
import ReactRange from "./ReactRange";
import ImageSlider from "./ImageSlider";

type VisualizationProps = {
  afterImageUrls: string[];
  procedureDisplayMessage: string;
  metaData: any;
};

const Visualization: React.FC<VisualizationProps> = ({
  procedureDisplayMessage,
  afterImageUrls,
  metaData,
}) => {
  const [values, setValues] = useState<number[]>([
    Math.round(afterImageUrls.length / 2),
  ]);

  const handleRangeChange = (values: number[]) => {
    setValues(values);
  };

  return (
    <div style={styles.container}>
      <ImageSlider values={values} afterImageUrls={afterImageUrls} />
      {procedureDisplayMessage && (
        <>
          <p style={styles.message}>{procedureDisplayMessage}</p>
          <div style={styles.rangeContainer}>
            <ReactRange
              values={values}
              min={0}
              max={afterImageUrls.length - 1}
              metaData={metaData}
              onChange={handleRangeChange}
            />
          </div>
        </>
      )}
    </div>
  );
};

const styles = {
  container: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    alignItems: "center",
    height: "100%",
  },
  message: {
    textAlign: "center",
    fontSize: "16px",
    marginTop: "10px",
    fontWeight: 700,
  },
  rangeContainer: {
    alignSelf: "center",
    width: "100%",
  },
} as const;

export default Visualization;
